import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { Store } from '../../../defaultState';

import { OrderbookStateT, OrderbookT } from 'types';

export const selectOrderbookState = (state: Store): OrderbookStateT => state.orderbook;

export const orderbookSelector: (state: Store) => OrderbookT = createDraftSafeSelector(
  selectOrderbookState,
  (orderState: OrderbookStateT) => orderState.orderbook
);
